/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Conheça novas pessoas, converse, divirta-se",
      "Número de telefone incorreto",
      "Baixar o aplicativo",
      "Continuar com Apple",
      "Continuar com o Facebook",
      "Continuar com o Google",
      "Entrar",
      "Registar-se",
      "Para continuar, digite os caracteres que vê na caixa em baixo.",
      "Continuar",
      "Digite os caracteres",
      "Verificação de segurança",
      "Atualizar",
      "Crie uma nova palavra-passe que seja fácil de lembrar:",
      "Atualizar",
      "Confirme palavra-passe",
      "A palavra-passe deve ter pelo menos {{num}} [[characters:num]]",
      "Palavra-passe",
      "Criar nova palavra-passe",
      "Blogue do Badoo",
      "Vagas",
      "Chat",
      "Cidades",
      "Gerir cookies",
      "Copyright (c) 2006 - presente. Bumble, todos os direitos reservados.",
      "A Apple e o logótipo da Apple são marcas registadas da Apple Inc.{{__EOL__}}Google Play é uma marca comercial da Google LLC.",
      "Instalar",
      "Facebook",
      "Siga-nos",
      "Centro de Apoio",
      "Instagram",
      "Idioma",
      "LinkedIn",
      "Informações Gerais",
      "Badoo é parte da Bumble Inc.",
      "Política de Privacidade",
      "Centro de Segurança",
      "Mapa do Site",
      "Sobre a Lei contra a escravidão moderna",
      "Termos e condições",
      "Twitter",
      "Insira o seu e-mail ou telemóvel e enviaremos as instruções para criar uma nova palavra-passe.",
      "Obter nova palavra-passe",
      "Insira o seu e-mail ou telemóvel",
      "Palavra-passe esquecida",
      "Modelos usados apenas como exemplos",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Não precisa de esperar por uma ligação.{{__EOL__}}{{__EOL__}}Mergulhe nas conversas que vão mais fundo e fale do que interessa. Aquelas coisas que fazem com que as pessoas se conheçam a sério.",
      "Quer conversar agora?",
      "Ao registar-se, concorda com os nossos <a class=\"link\" href=\"{{terms_url}}\">Termos & Condições</a>. Saiba como usamos os seus dados na nossa <a class=\"link\" href=\"{{privacy_url}}\">Política de Privacidade</a>",
      "Queremos ajudar a mostrar o seu eu real, <br />para ter encontros que sabem bem.",
      "Para encontros com confiança",
      "Ou",
      "Já tem uma conta?",
      "Registe-se com o seu endereço de e-mail ou número de telemóvel",
      "Obtenha o que quer dos seus relacionamentos.{{__EOL__}}Sem desculpas.",
      "Quer apenas conversar? Tudo bem.{{__EOL__}}Quer assentar? Boa.{{__EOL__}}{{__EOL__}}E se mudar de ideias, tudo bem na mesma.",
      "Encontros casuais",
      "Quero um relacionamento",
      "Quero conversar",
      "Encontre pessoas que querem o mesmo que você.",
      "{{name}}, {{age}}",
      "A sua segurança é a nossa prioridade.",
      "O nosso Centro de Segurança é a nossa área de informações, onde poderá encontrar todo o apoio de que precisa para ter encontros com confiança.",
      "Visite o nosso Centro de Segurança",
      "Segurança em primeiro lugar,<br/>sempre.",
      "Eu sabia desde o início que íamos dar certo...",
      "No início, eu não estava à procura de nada sério...",
      "Um conselho para quem está na app do Badoo é ser quem realmente é...",
      "Histórias de sucesso do Badoo",
      "Veja mais histórias de sucesso",
      "{{num}}__CUT__Pontuação",
      "Apple App Store",
      "Confie em nós! Já ajudámos a criar milhões e milhões de casais desde 2006.",
      "{{num}}M+__CUT__Downloads",
      "+ de {{num}}M",
      "Google Play Store",
      "Sabemos o que estamos a fazer.",
      "Entrar com e-mail ou telemóvel",
      "Insira a sua palavra-passe",
      "Esqueceu-se da palavra-passe?",
      "Registar-se",
      "Ainda não tem uma conta?",
      "Entrar",
      "Registar-se"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "caracteres"
            ],
            "singular": [
                  "caracter"
            ]
      },
      "day": {
            "plural": [
                  "dias"
            ],
            "singular": [
                  "dia"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mês"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "year": {
            "plural": [
                  "anos"
            ],
            "singular": [
                  "ano"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
